<template>
    <button class="button button_view_icon button_theme_base mtb__-4"
            :disabled="disabled"
            @click.stop="setUnitFns"
    >
        <span class="icon">
            <span class="icon__symbol">
                <SvgIcon class="icon" name="common__edit_lg" />
            </span>
        </span>
    </button>
</template>
<script>
    export default {
        name: 'ShipmentList_menu_edit',
        mixins: [],
        props: {
            packageId: Number,
            disabled: Boolean,
        },
        data() {
            return {}
        },
        computed: {
        },
        methods: {
            setUnitFns() {
                this.setRoute.shipmentEditPackage(this.$route, this.$router, this.packageId);
            },
        },
    }
</script>